import { CapacitorHttp } from '@capacitor/core';

const API = "https://dolphin-app-33jp4.ondigitalocean.app";

// ✅ Capacitor HTTP - SSL bypass for Android TV
export const fetchAPI = async (endpoint) => {
  try {
    const response = await CapacitorHttp.get({
      url: `${API}${endpoint}`,
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    // Fallback to regular fetch
    const res = await fetch(`${API}${endpoint}`);
    return res.json();
  }
};

export default API;